import WIPFeaturesContext from 'context/wip-features/wip-features.context';
import { useI18n } from 'hooks/useI18n';
import { UIOfferHowSection } from 'interfaces/ui/ui-offer-how-section';
import { useContext } from 'react';
import JobOfferLongText from '../JobOfferLongText';
import JobOfferSection from '../JobOfferSection';
import HowItem from './HowItem';
import { StyledHowSection } from './HowSection.styled';

const HowSection = ({
  howIntro,
  howItems,
  migratedToMarkdown
}: UIOfferHowSection) => {
  const { t } = useI18n('job-offer');
  const showWIPFeatures = useContext(WIPFeaturesContext);

  return (
    <JobOfferSection name="como" title={t('titles.how')}>
      <JobOfferLongText isMarkdown={migratedToMarkdown}>
        {howIntro}
      </JobOfferLongText>
      {showWIPFeatures && howItems?.length > 0 && (
        <StyledHowSection>
          {howItems.map((i) => (
            <HowItem
              key={i.id}
              howItemKey={i.id}
              howItemTitle={i.title}
              howItemText={i.text}
            />
          ))}
        </StyledHowSection>
      )}
    </JobOfferSection>
  );
};

export default HowSection;
